document.addEventListener("DOMContentLoaded", function () {
  let products_on_page = document.getElementById("product-grid");
  let next_url_raw = products_on_page ? products_on_page.dataset.nextUrl : null;
  // Handle undefined, null, and empty string - convert all to null
  let next_url = (next_url_raw !== undefined && next_url_raw !== null && String(next_url_raw).trim() !== '') ? String(next_url_raw).trim() : null;
  
  console.log('Initial load:', {
    next_url_raw: next_url_raw,
    next_url: next_url,
    hasAttribute: products_on_page ? products_on_page.hasAttribute('data-next-url') : false
  });
  let load_more_btn = document.getElementsByClassName("load-more_btn")[0];
  let load_more_spinner =
    document.getElementsByClassName("load-more_spinner")[0];
  let progress_bar = document.getElementById("progress-bar");
  let current_products_span = document.getElementById("current-products");
  let total_products_span = document.getElementById("total-products");

  let productListInner = document.querySelector(
    "#ProductGridContainer .collection"
  );
  if (!productListInner) return;
  productListInner.classList.add("smarte-load-context");

  function requeryElements() {
    products_on_page = document.getElementById("product-grid");
    load_more_btn = document.getElementsByClassName("load-more_btn")[0];
    load_more_spinner = document.getElementsByClassName("load-more_spinner")[0];
    progress_bar = document.getElementById("progress-bar");
    current_products_span = document.getElementById("current-products");
    total_products_span = document.getElementById("total-products");
    const next_url_raw = products_on_page ? products_on_page.dataset.nextUrl : null;
    next_url = (next_url_raw !== undefined && next_url_raw !== null && String(next_url_raw).trim() !== '') ? String(next_url_raw).trim() : null;
  }

  // Helper function to construct next URL from current URL
  function constructNextUrl(currentUrl) {
    if (!currentUrl) return null;
    try {
      const url = new URL(currentUrl, window.location.origin);
      const currentPage = parseInt(url.searchParams.get('page') || '1', 10);
      url.searchParams.set('page', String(currentPage + 1));
      return url.pathname + url.search;
    } catch (e) {
      console.error('Error constructing next URL:', e);
      return null;
    }
  }

  function updateStatus() {
    if (
      !products_on_page ||
      !current_products_span ||
      !total_products_span ||
      !progress_bar
    )
      return;
    const total_products = parseInt(total_products_span.innerText || "0", 10);
    const current_count =
      products_on_page.querySelectorAll(".grid__item").length;
    const display_count = Math.min(
      current_count,
      isNaN(total_products) ? current_count : total_products
    );
    const percentage_displayed =
      total_products > 0
        ? Math.min(100, (display_count / total_products) * 100)
        : 0;
    current_products_span.innerText = display_count;
    progress_bar.style.width = `${percentage_displayed}%`;

    // Show/hide load more button based on whether there are more products
    // First check: if we've reached all products, always hide the button
    const hasMoreProducts = display_count < total_products;
    
    if (!hasMoreProducts) {
      // All products are displayed, hide button and clear next_url
      if (load_more_btn) {
        load_more_btn.style.display = "none";
      }
      next_url = null; // Clear next_url since we're done
      console.log('All products displayed, hiding button');
      return;
    }
    
    // We have more products to load, check if we have a valid next_url
    const hasValidNextUrl = next_url && typeof next_url === 'string' && next_url.trim() !== '';
    
    // If next_url is null but we have more products, try to construct it
    if (!hasValidNextUrl && next_url === null) {
      // Try to construct next URL from last fetched URL or current page URL
      const baseUrl = lastFetchedUrl || window.location.href;
      const constructedUrl = constructNextUrl(baseUrl);
      if (constructedUrl) {
        next_url = constructedUrl;
        console.log('Constructed next_url in updateStatus:', next_url);
      }
    }
    
    // Show button only if we have more products AND (we have a valid next_url OR can construct one)
    const finalHasValidNextUrl = next_url && typeof next_url === 'string' && next_url.trim() !== '';
    const shouldShowButton = hasMoreProducts && finalHasValidNextUrl;
    
    // Debug logging
    console.log('updateStatus:', {
      next_url: next_url,
      hasValidNextUrl: finalHasValidNextUrl,
      display_count: display_count,
      total_products: total_products,
      current_count: current_count,
      hasMoreProducts: hasMoreProducts,
      shouldShowButton: shouldShowButton
    });
    
    if (load_more_btn) {
      if (shouldShowButton) {
        load_more_btn.style.display = "flex";
      } else {
        load_more_btn.style.display = "none";
      }
    }
  }

  // Function to fetch the next page of products with retry logic
  async function getNextPage(retries = 3) {
    console.log(next_url,'next_url11________________');
    for (let attempt = 1; attempt <= retries; attempt++) {
      try {
        let res = await fetch(next_url);
        if (res.ok) {
          return await res.text();
        } else {
          throw new Error(`HTTP ${res.status}: ${res.statusText}`);
        }
      } catch (error) {
        console.log(`Fetch attempt ${attempt}/${retries} failed:`, error);
        if (attempt < retries) {
          // Wait before retrying (exponential backoff)
          await new Promise(resolve => setTimeout(resolve, 1000 * attempt));
        } else {
          console.error('All fetch attempts failed');
          return null;
        }
      }
    }
    return null;
  }

  // Function to load more products
  let isLoading = false;
  // Track the last URL we successfully fetched - initialize with current page if next_url exists
  let lastFetchedUrl = next_url ? (window.location.pathname + window.location.search) : null;
  
  async function loadMoreProducts() {
    if (!products_on_page || isLoading) return;
    
    // If next_url is null, try to construct it from the last fetched URL or current location
    if (!next_url) {
      const baseUrl = lastFetchedUrl || window.location.href;
      const constructedUrl = constructNextUrl(baseUrl);
      if (constructedUrl) {
        next_url = constructedUrl;
        console.log('Constructed next_url for loading:', next_url);
      } else {
        console.error('Cannot load more: no next_url and cannot construct one');
        return;
      }
    }

    // Store the URL we're about to fetch
    const urlToFetch = next_url;
    lastFetchedUrl = urlToFetch;

    isLoading = true;
    if (load_more_btn) load_more_btn.style.display = "none";
    if (load_more_spinner) load_more_spinner.style.display = "block";

    try {
      let nextPage = await getNextPage();
      if (!nextPage) {
        throw new Error("Failed to fetch next page");
      }

      const parser = new DOMParser();
      const nextPageDoc = parser.parseFromString(nextPage, "text/html");

      if (load_more_spinner) load_more_spinner.style.display = "none";

      const productgrid = nextPageDoc.getElementById("product-grid");
      if (!productgrid) {
        throw new Error("Product grid not found in response");
      }

      const new_products = productgrid.getElementsByClassName("grid__item");
      const new_url = productgrid.dataset.nextUrl;

      // Get count before appending
      const countBefore = products_on_page.querySelectorAll(".grid__item").length;
      
      // Update next_url before calling updateStatus so it can check properly
      // Handle both undefined and empty string cases
      let updated_next_url = (new_url !== undefined && new_url !== null && String(new_url).trim() !== '') ? String(new_url).trim() : null;
      
      // If new_url is empty/undefined, try to construct next URL from the URL we just fetched
      // This handles cases where the page returns products but no next_url attribute
      if (!updated_next_url) {
        // Use the URL we just fetched to construct the next one
        const constructedUrl = constructNextUrl(urlToFetch);
        if (constructedUrl) {
          updated_next_url = constructedUrl;
          console.log('Constructed next_url from fetched URL:', updated_next_url);
        }
      }
      
      next_url = updated_next_url;

      console.log('After loading:', {
        new_url: new_url,
        next_url: next_url,
        new_products_count: new_products.length,
        productgrid_has_nextUrl: productgrid.hasAttribute('data-next-url'),
        countBefore: countBefore
      });

      // Append the new products to the current product grid
      // Convert to array first to avoid live collection issues
      const productsArray = Array.from(new_products);
      let appendedCount = 0;
      
      for (let i = 0; i < productsArray.length; i++) {
        try {
          products_on_page.appendChild(productsArray[i]);
          appendedCount++;
        } catch (e) {
          console.error(`Error appending product ${i}:`, e);
        }
      }

      // Get count after appending
      const countAfter = products_on_page.querySelectorAll(".grid__item").length;
      const actualAdded = countAfter - countBefore;
      
      console.log('After appending:', {
        expectedToAdd: productsArray.length,
        actuallyAdded: actualAdded,
        appendedCount: appendedCount,
        countBefore: countBefore,
        countAfter: countAfter
      });

      updateStatus();
    } catch (error) {
      console.error("Error loading more products:", error);
      if (load_more_spinner) load_more_spinner.style.display = "none";
      if (load_more_btn) load_more_btn.style.display = "flex";
    } finally {
      isLoading = false;
    }
  }
  // Make available for inline onclick handlers from Liquid templates
  window.loadMoreProducts = loadMoreProducts;

  // Delegated click handler so it survives DOM replacements
  document.addEventListener("click", function (evt) {
    const trigger = evt.target.closest(".load-more_btn");
    if (trigger) {
      evt.preventDefault();
      loadMoreProducts();
    }
  });

  // Observe facet/grid re-renders and re-initialize
  const facetMain = document.querySelector("#ProductGridContainer");
  if (facetMain) {
    let scheduled = false;
    const mo = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        if (!document.querySelector(".smarte-load-context")) {
          let productListInner = document.querySelector(
            "#ProductGridContainer .collection"
          );
          if (!productListInner) return;
          productListInner.classList.add("smarte-load-context");
          console.log('productListInner mutating');
          requeryElements();
          updateStatus();
        }
      });
    });
    mo.observe(facetMain, { childList: true, subtree: true });
  }

  // Initial status on first paint
  updateStatus();
});
